import HttpResponse from '../../components/layouts/HttpResponse';

const NotFound = () => {
  return <HttpResponse number="404" text="Page not found" />;
};

export default NotFound;
